import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=0c0e25f6&scoped=true&"
import script from "./order_info.vue?vue&type=script&lang=ts&"
export * from "./order_info.vue?vue&type=script&lang=ts&"
import style0 from "./order_info.vue?vue&type=style&index=0&id=0c0e25f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e25f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCardText,VCardTitle,VChip})
